import { useEffect, useState } from 'react'
import { Grid, Typography } from '@material-ui/core'
import useAppState from '../../services/useAppState'
import {makeStyles} from '@material-ui/core/styles'
import Notify from '../Notify'
import SurveyForm from './SurveyForm'
import {useHistory} from 'react-router-dom'
import { getTemplates } from '../../services/whatsApp'
import LoadingModal from '../LoadingModal'

const useStyles = makeStyles({
  root: {
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px'
  },
  selected: {
    backgroundColor: 'rgb(56, 52, 150)'
  }
})

export default function MakeSurvey () {
  const classes = useStyles()
  const history = useHistory()
  const {organization} = useAppState()
  const [notify, setNotify] = useState({variant: null, message: null, show: false})
  const [loading, setLoading] = useState(true)
  const [whatsAppTemplates, setWhatsAppTemplates] = useState([])

  const fetchTemplates = async () => {
    const response = await getTemplates({ organizationId: organization.id })
    console.log('MakeSurvey.response', response)
    // filter by event type
    setWhatsAppTemplates(response.data.templates.filter(template => template.status === 'approved'))
    console.log('MakeSurvey.whatsAppTemplates', response.data.templates.filter(template => template.status === 'approved'))
    setLoading(false)
  }

  const onNotifyClose = () => {
    console.log('close notify')
    setNotify({variant: null, message: null, show: false})
  }

  const exitMakeSurvey = () => {
    history.push('/surveys')
  }

  
  useEffect(() => {
    console.log('MakeSurvey.organization', organization)
    if (organization && organization.communication_methods.includes('whatsapp')) {
      fetchTemplates()
    } else {
      setLoading(false)
    }
  }, [organization])

  if (loading) {
    return <LoadingModal />
  }

  return (
    <div>
      <Grid spacing={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant={'h3'}>Create a Survey</Typography>
            
            <SurveyForm
              organizationId={organization.id}
              onDone={exitMakeSurvey}
              communication_methods={organization.communication_methods}
              whatsAppTemplates={whatsAppTemplates}
            />
          </Grid>
        </Grid>
      </Grid>
      {notify.show && <Notify variant={notify.variant} onClose={onNotifyClose} message={notify.message} />}
    </div>
  )
}